export default (_theme) => ({
  root: {
    width: 28,
    height: 16,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },

  bar: {
    width: 4,
    height: 3,
    background: '#E1E9F0',
    borderRadius: 1,

    '&:nth-child(1)': {
      height: 3,
    },
    '&:nth-child(2)': {
      height: 7,
    },
    '&:nth-child(3)': {
      height: 12,
    },
    '&:nth-child(4)': {
      height: 16,
    },
    '&:nth-child(5)': {
      height: 20,
    },
  },

  barSelected: {
    background: '#148CFC',
  },

  whiteVariant: {
    '& $bar': {
      background: 'rgba(255, 255, 255, 0.2)',
    },
    '& $barSelected': {
      background: 'white',
    },
  },
});
